import React from 'react';
import { X, BookOpen } from 'lucide-react';

/**
 * A reusable info modal component for displaying instructions/guides
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {Function} props.onClose - Function to call when closing the modal
 * @param {string} props.title - Modal title
 * @param {React.ReactNode} props.children - Modal content
 */
export const InfoModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
        <div className="flex items-center p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="bg-blue-100 dark:bg-blue-900 p-2 rounded-full mr-3">
            <BookOpen className="h-5 w-5 text-blue-600 dark:text-blue-300" />
          </div>
          <h3 className="text-lg text-gray-900 dark:text-white font-medium font-unna">{title}</h3>
          <button
            onClick={onClose}
            className="ml-auto bg-gray-200 dark:bg-gray-700 font-rasa rounded-full p-1 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            <X className="h-4 w-4 text-gray-700 dark:text-gray-300" />
          </button>
        </div>

        <div className="overflow-y-auto p-4 text-base font-rasa text-gray-700 dark:text-gray-300">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
